import { createVueComponent } from '../../functions/create-vue-component';
import Component from './index.vue';

export function createPackages(elementId) {
    createVueComponent(elementId, Component);
}